(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-accordions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('oke_connect_cart_itemVariantAdded', async (event) => {
    window.theme.CartDrawer.refresh().then(() => {
      window.theme.CartDrawer.handleGWP();
      window.theme.CartDrawer.open();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
